import React from 'react';
import { Code } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Footer = () => {
  const { personal } = portfolioData;
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const footerLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Projects' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <footer className="py-12 px-6 border-t" style={{
      background: 'var(--bg-primary)',
      borderColor: 'var(--border)'
    }}>
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: 'var(--accent)' }}>
                <Code className="h-5 w-5" style={{ color: '#000' }} />
              </div>
              <span className="text-xl font-bold" style={{
                color: 'var(--text-primary)',
                fontFamily: 'JetBrains Mono, monospace'
              }}>{personal.name}</span>
            </div>
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
              {personal.title}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4" style={{
              color: 'var(--text-primary)',
              fontFamily: 'JetBrains Mono, monospace'
            }}>Quick Links</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-left text-sm transition-colors"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4" style={{
              color: 'var(--text-primary)',
              fontFamily: 'JetBrains Mono, monospace'
            }}>Contact</h3>
            <div className="space-y-2 text-sm">
              <p style={{ color: 'var(--text-secondary)' }}>
                <a href={`mailto:${personal.email}`} className="transition-colors">
                  {personal.email}
                </a>
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>{personal.location}</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-8 text-center" style={{ borderColor: 'var(--border)' }}>
          <p className="text-sm" style={{
            color: 'var(--text-muted)',
            fontFamily: 'JetBrains Mono, monospace'
          }}>
            © {currentYear} {personal.name}. Built with React & FastAPI
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
